module.exports = __webpack_public_path__ + "static/media/riwayat_pembayaran.46d2a861.png";